export default {
    SET_CANCEL_TOKEN: (state, { token, fileName }) => {
        state.uploadCancelTokens.push({ token, fileName })
    },

    REMOVE_CANCEL_TOKEN: (state, tokenIndex) => {
        state.uploadCancelTokens.splice(tokenIndex, 1)
    },

    ABORT_FILE_UPLOAD: (state, fileName) => {
        const index = state.uploadCancelTokens.findIndex(item => item.fileName === fileName)

        state.uploadCancelTokens[index].token.cancel('canceled')
    },
}
